import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {MenuComponent} from '../assets/ts/components'

const PromoLayout = () => {
  const location = useLocation()

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root vh-100 overflow-hidden'>
        <div className='page d-flex flex-row flex-column-fluid overflow-hidden h-100'>
          <AsideDefault />
          <div
            className='wrapper d-flex flex-column flex-row-fluid overflow-hidden h-100'
            id='kt_wrapper'
            style={{marginLeft: '220px'}}
          >
            <HeaderWrapper isPromo={true} />
            <div
              id='kt_content'
              className='content d-flex flex-column flex-grow-1 overflow-hidden h-100'
              style={{minHeight: 0}}
            >
              <Outlet />
            </div>
          </div>
        </div>
      </div>
      <ScrollTop />
    </PageDataProvider>
  )
}

export {PromoLayout}
